import { Link } from "react-router-dom"
import Img from "./Img"

const FooterSignedin = () => {
    return (
        <section className="text-white w-full bg-[#000A22] z-50" id="footer">
            <div className="flex flex-wrap gap-1 items-center justify-around capitalize py-8">
                <Link to={'/about'}>about</Link>
                <Link to={'/contactus'}>contact us</Link>
                <Link to={'/FAQs'}>FAQs</Link>
                <Link to={'/listCompany'}>List Your Company</Link>
                <Link to={'/termsofservice'}>terms of service</Link>
                <Link to={'/useragreement'}>user agreement</Link>
                <Img
                    src="/Murwiza-white.svg"
                    alt="Logo"
                    width={126}
                    height={20}
                />
            </div>
        </section>
    )
}

export default FooterSignedin